import { HeadingPlugin } from "@platejs/basic-nodes/react";
import { BlockquotePlugin } from "@platejs/basic-nodes/react";
import {
  BoldPlugin,
  ItalicPlugin,
  CodePlugin,
} from "@platejs/basic-nodes/react";
import { ListPlugin } from "@platejs/list-classic/react";
import { LinkPlugin } from "@platejs/link/react";
import { HorizontalRulePlugin } from "@platejs/basic-nodes/react";
import { ParagraphPlugin } from "platejs/react";
import { CursorOverlay } from "../CursorOverlay";
import { FloatingLinkEditor } from "../FloatingLinkEditor";
import { isMissingProtocol } from "../../../utils/SchoolBlocksUtilities";
import { DocxPlugin } from "@platejs/docx";
import { BlockPlaceholderPlugin } from "platejs/react";
import styles from "../styles/SlateEditor.module.scss";
import { CursorOverlayPlugin } from "@platejs/selection/react";
import { ExitBreakPlugin } from "platejs";
import { toNodeProps } from "./withNodeProps";

export const basePlatePlugins = [
  ParagraphPlugin.configure({
    parsers: {
      html: {
        deserializer: {
          toNodeProps,
        },
      },
    },
  }),
  HeadingPlugin.configure({
    parsers: {
      html: {
        deserializer: {
          toNodeProps,
        },
      },
    },
  }),
  BlockquotePlugin.configure({
    parsers: {
      html: {
        deserializer: {
          toNodeProps,
        },
      },
    },
  }),
  BoldPlugin,
  ItalicPlugin,
  CodePlugin,
  ListPlugin.configure({
    parsers: {
      html: {
        deserializer: {
          toNodeProps,
        },
      },
    },
  }),
  ExitBreakPlugin.configure({
    shortcuts: {
      insert: { keys: "mod+enter" },
      insertBefore: { keys: "mod+shift+enter" },
    },
  }),
  LinkPlugin.extend({
    render: { afterEditable: () => <FloatingLinkEditor /> },
    options: {
      transformInput: (url) => {
        if (isMissingProtocol(url)) {
          url = "https://" + url;
        }
        return url;
      },
    },
    parsers: {
      html: {
        deserializer: {
          toNodeProps,
        },
      },
    },
  }),
  HorizontalRulePlugin,
  CursorOverlayPlugin.configure({
    render: { afterEditable: () => <CursorOverlay /> },
  }),
  DocxPlugin,
  BlockPlaceholderPlugin.configure({
    options: {
      className: styles.paragraphPlaceholder,
    },
  }),
];
